const shortcutLaunchQuery = "launch=shortcut";

export default shortcutLaunchQuery;
